import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    items: [],
  },
  mutations: {
    SET_ITEMS(state, items) {
      // eslint-disable-next-line no-param-reassign
      state.items = items;
    },
  },
  actions: {
    loadItems({ commit }) {
      axios
        .get('./content.json')
        .then(response => response.data)
        .then((items) => {
          commit('SET_ITEMS', items);
        });
    },
  },
});
